(() => {
  const section = document.querySelector('[data-routine-builder]');
  if (!section || section.dataset.initialized) return;
  section.dataset.initialized = 'true';
  const find = selector => section.querySelector(selector);
  const words = JSON.parse(find('[data-routine-words]').textContent);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: document.body.dataset.currency || 'USD' }).format(cents / 100);
  const cards = [...section.querySelectorAll('[data-bundle-card]')];
  const selected = new Map();
  const list = find('.bundle-items');
  const choices = find('[data-purchase-choices]');
  const once = find('[value="once"]');
  const subscribe = find('[value="subscribe"]');
  const schedule = find('[data-routine-schedule]');
  const scheduleWrap = find('[data-schedule-wrap]');
  const notice = find('[data-routine-notice]');
  const submit = find('.bundle-submit');
  const message = find('.bundle-message');
  let mode = 'once';
  let planId = '';
  let busy = false;
  const eligiblePlan = (plan, item) => plan.recurring === true && Number.isFinite(plan.price) && Math.abs(plan.price - Math.round(item.price * 0.9)) <= 1 && plan.checkoutPrice === plan.price && plan.deliveryPrice === plan.price;
  const sharedPlans = () => {
    const items = [...selected.values()];
    if (!items.length) return [];
    return items[0].plans.filter(plan => eligiblePlan(plan, items[0]) && items.every(item => item.plans.some(other => String(other.id) === String(plan.id) && eligiblePlan(other, item))));
  };
  const selectedPlan = item => item.plans.find(plan => String(plan.id) === planId && eligiblePlan(plan, item));
  const valid = () => selected.size >= 2 && (mode === 'subscribe' ? sharedPlans().some(plan => String(plan.id) === planId) : ![...selected.values()].some(item => item.required));
  const render = () => {
    const shared = sharedPlans();
    const needsPlan = [...selected.values()].some(item => item.required);
    if (needsPlan) mode = 'subscribe';
    if (!selected.size) { mode = 'once'; planId = ''; }
    if (!planId && shared.length) planId = String(shared[0].id);
    schedule.replaceChildren();
    if (planId && !shared.some(plan => String(plan.id) === planId)) {
      const option = document.createElement('option');
      option.value = ''; option.textContent = words.choose_schedule; option.disabled = true;
      schedule.append(option);
    }
    shared.forEach(plan => { const option = document.createElement('option'); option.value = String(plan.id); option.textContent = plan.name; schedule.append(option); });
    schedule.value = shared.some(plan => String(plan.id) === planId) ? planId : '';
    schedule.disabled = busy || !shared.length;
    choices.hidden = selected.size === 0;
    once.checked = mode === 'once'; once.disabled = busy || needsPlan;
    subscribe.checked = mode === 'subscribe'; subscribe.disabled = busy || !shared.length;
    scheduleWrap.hidden = mode !== 'subscribe';
    notice.hidden = mode !== 'subscribe' || shared.some(plan => String(plan.id) === planId);
    notice.textContent = shared.length ? words.choose_schedule : words.unavailable;
    list.replaceChildren();
    let subtotal = 0;
    let total = 0;
    selected.forEach((item, id) => {
      const plan = mode === 'subscribe' ? selectedPlan(item) : null;
      subtotal += item.price;
      total += plan ? plan.price : item.price;
      const row = document.createElement('div'); row.className = 'bundle-item';
      const head = document.createElement('div'); head.className = 'bundle-item-head';
      const name = document.createElement('strong'); name.textContent = item.name;
      const price = document.createElement('span'); price.textContent = money(plan ? plan.price : item.price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.disabled = busy;
      remove.setAttribute('aria-label', words.remove.replace('{product}', item.name));
      remove.addEventListener('click', () => { toggle(item.card); item.card.querySelector('.bundle-select').focus(); });
      head.append(name, price, remove); row.append(head); list.append(row);
    });
    find('[data-bundle-total]').textContent = money(total);
    find('[data-total-label]').textContent = mode === 'subscribe' ? words.per_delivery : words.subtotal;
    const savings = find('[data-routine-savings]');
    savings.hidden = mode !== 'subscribe' || !valid();
    savings.textContent = words.saving.replace('{amount}', money(subtotal - total));
    const renewal = find('[data-routine-renewal]');
    renewal.hidden = mode !== 'subscribe';
    renewal.textContent = words.renewal;
    find('.bundle-count').textContent = selected.size ? words.count.replace('{count}', String(selected.size)) : words.empty;
    find('.bundle-empty').hidden = selected.size > 0;
    submit.disabled = busy || !valid();
    submit.textContent = busy ? words.working : mode === 'subscribe' ? words.add_subscription : words.add_once;
    cards.forEach(card => { if (card.dataset.available !== 'false') card.querySelector('.bundle-select').disabled = busy; });
  };
  const toggle = card => {
    if (busy || card.querySelector('.bundle-select').disabled) return;
    const id = card.dataset.id;
    const button = card.querySelector('.bundle-select');
    if (selected.has(id)) {
      selected.delete(id); button.setAttribute('aria-pressed', 'false'); button.textContent = words.select;
    } else {
      selected.set(id, { card, name: card.querySelector('h3').textContent, price: Number(card.dataset.price), required: card.dataset.requiresPlan === 'true', plans: JSON.parse(card.querySelector('.bundle-plans').textContent) });
      button.setAttribute('aria-pressed', 'true'); button.textContent = words.selected;
    }
    message.textContent = ''; render();
  };
  cards.forEach(card => { const button = card.querySelector('.bundle-select'); card.dataset.available = String(!button.disabled); button.addEventListener('click', () => toggle(card)); });
  [once, subscribe].forEach(input => input.addEventListener('change', () => { mode = input.value; message.textContent = ''; render(); }));
  schedule.addEventListener('change', () => { planId = schedule.value; message.textContent = ''; render(); });
  section.querySelectorAll('.bundle-filters button').forEach(button => button.addEventListener('click', () => {
    section.querySelectorAll('.bundle-filters button').forEach(other => { other.classList.toggle('active', other === button); other.setAttribute('aria-pressed', String(other === button)); });
    cards.forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.type !== button.dataset.filter; });
  }));
  submit.addEventListener('click', async () => {
    if (busy || !valid()) return;
    const items = [...selected].map(([id, item]) => {
      const entry = { id, quantity: 1 };
      if (mode === 'subscribe') entry.selling_plan = selectedPlan(item).id;
      return entry;
    });
    busy = true; message.textContent = words.working; render();
    try {
      const root = document.body.dataset.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || words.error);
      window.location.assign(root + 'cart');
    } catch (error) { message.textContent = error.message || words.error; busy = false; render(); }
  });
  render();
})();
